import { AlignCenter, AlignJustify, AlignLeft, AlignRight } from '@untitled-ui/icons-react';

import { tNamespace } from '../../services/translation';
import { IconButton } from '../buttons/icon-button';
import { AppDropdownBody, DropdownMenu } from '../dropdown-menu';
import { DropdownMenuOption } from '../menu-option';
import { Tooltip } from '../tooltip';

const t = tNamespace('components.editor.text-align-dropdown');

export type TextAlignDropdownProps = {
  onSelectAlignLeft: () => unknown;
  onSelectAlignRight: () => unknown;
  onSelectAlignCenter: () => unknown;
  onSelectJustify: () => unknown;
  disabled?: boolean;
  container?: Element;
};

export function TextAlignDropdown(props: TextAlignDropdownProps) {
  const {
    onSelectAlignLeft,
    onSelectAlignRight,
    onSelectAlignCenter,
    onSelectJustify,
    disabled = false,
    container,
  } = props;
  return (
    <DropdownMenu
      sideOffset={5}
      position="start"
      closeOnSelect={true}
      disabled={disabled}
      container={container}
      trigger={
        <Tooltip text={t('textAlignment')}>
          <div>
            <IconButton icon={AlignLeft} isDiv className="text-black" disabled={disabled} />
          </div>
        </Tooltip>
      }
      triggerClassName="data-[disabled]:bg-white"
    >
      <AppDropdownBody>
        <DropdownMenuOption
          leftElement={<AlignLeft width={16} height={16} className="text-black" />}
          mainText={t('alignLeft')}
          onClick={onSelectAlignLeft}
        />
        <DropdownMenuOption
          leftElement={<AlignRight width={16} height={16} className="text-black" />}
          mainText={t('alignRight')}
          onClick={onSelectAlignRight}
        />
        <DropdownMenuOption
          leftElement={<AlignJustify width={16} height={16} className="text-black" />}
          mainText={t('justifyText')}
          onClick={onSelectJustify}
        />
        <DropdownMenuOption
          leftElement={<AlignCenter width={16} height={16} className="text-black" />}
          mainText={t('alignCenter')}
          onClick={onSelectAlignCenter}
        />
      </AppDropdownBody>
    </DropdownMenu>
  );
}
